import { Col, Form, Row } from "antd";
import { useTranslation } from "react-i18next";
import popupBackgroundDefaultImage from "../../../assets/images/default-popup-background.png";
import "./advertising-popup.component.scss";
import FnbSelectHyperlinkCustomize from "../../../components/fnb-select-hyperlink-customize/fnb-select-hyperlink-customize";
import FnbUploadBackgroundImageCustomizeComponent from "../../../components/fnb-upload-background-image-customize/fnb-upload-background-image-customize";
import { useEffect } from "react";
import CustomizationCollapseBlock from "../../../components/customization-block-component/customization-block.page";
import {
  POPUP_BANNER_DEFAULT_BEST_DISPLAY,
  POPUP_BANNER_MAX_SIZE_UPLOAD,
} from "../../../constants/advertising-popup.constants";
import { DYNAMIC_HYPERLINK, HYPERLINK_SELECT_OPTION_AD_POPUP } from "../../../constants/hyperlink.constants";

export default function AdvertisingPopupCustomizeComponent(props) {
  console.log("props AdvertisingPopupCustomizeComponent", props);
  const { form, prepareDataForHyperlink, updateFormValues, onChange } = props;
  const [t] = useTranslation();
  const { getFieldsValue } = form;
  const translateData = {
    title: t("storeWebPage.banner.title"),
    hyperlink: t("storeWebPage.advertisingPopup.hyperlink"),
    placeholder: t("storeWebPage.advertisingPopup.placeholder"),
    validateImageMessage: t("storeWebPage.advertisingPopup.validateImageMessage"),
  };

  useEffect(() => {
    if (updateFormValues) {
      updateFormValues();
    }
  }, []);

  const onChangeHyperlinkType = (e, index) => {
    const changedValue = {
      key: ["config", "advertisingPopup", "popupLink", "hyperlinkType"],
      value: e,
    };

    if (onChange) {
      onChange(changedValue);
    }

    const onChangeHyperlinkValue = {
      key: ["config", "advertisingPopup", "popupLink", "hyperlinkValue"],
      value: DYNAMIC_HYPERLINK.includes(e) ? null : "#",
    };
    if (onChange) {
      onChange(onChangeHyperlinkValue);
    }
  };

  const renderGeneralCustomization = () => {
    return (
      <>
        <Row className="select-banner-popup">
          <Col span={24}>
            <h4>
              {translateData.title}
              <span className="text-danger">*</span>
            </h4>
          </Col>
          <Col span={24}>
            <Form.Item
              className="background-section-image"
              rules={[
                {
                  required: true,
                  message: translateData.validateImageMessage,
                },
              ]}
              name={["config", "advertisingPopup", "banner", "backgroundImage"]}
            >
              <FnbUploadBackgroundImageCustomizeComponent
                bestDisplay={POPUP_BANNER_DEFAULT_BEST_DISPLAY}
                maxSizeUploadMb={POPUP_BANNER_MAX_SIZE_UPLOAD}
                isRequired={false}
                defaultImage={popupBackgroundDefaultImage}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <FnbSelectHyperlinkCustomize
              showSearch
              allowClear
              fixed={false}
              placeholder={translateData.placeholder}
              defaultValue={getFieldsValue()?.config?.advertisingPopup?.popupLink?.hyperlinkType}
              onChangeHyperlinkType={(e) => onChangeHyperlinkType(e)}
              formItemHyperlinkTypePath={["config", "advertisingPopup", "popupLink", "hyperlinkType"]}
              formItemHyperlinkValuePath={["config", "advertisingPopup", "popupLink", "hyperlinkValue"]}
              prepareDataForHyperLink={prepareDataForHyperlink}
              option={HYPERLINK_SELECT_OPTION_AD_POPUP}
              form={props?.form}
              fieldPreName={[]}
            />
          </Col>
        </Row>
      </>
    );
  };

  return (
    <CustomizationCollapseBlock
      props={props}
      title={translateData.title}
      isNormal={true}
      content={renderGeneralCustomization()}
      defaultActiveKey={1}
      isShowKey={true}
    />
  );
}
